import React, { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import { useUser } from '../context/user.context';
import { getDayIndex } from '../misc/helpers';

// ======================================================= //

export default function AddPeriod({open, adding, setAddOpen, index}) {

    const {user, updateUser} = useUser();

    const [name, setName] = useState('');
    const [link, setLink] = useState('');

    // ------------------------------------------------------- //

    const handleClose = () => {
        setAddOpen(false);
    }

    const handleAdd = () => {

        const dayIndex = getDayIndex(adding.day);
        const periods = user.tables[index].days[dayIndex].periods;

        periods[adding.index] = {
            name: name,
            link: link
        }

        const new_user = {...user};
        new_user.tables[index].days[dayIndex].periods = periods;
        
        updateUser(new_user);
        handleClose();
    }

    const addEnabled = () => {

        if(name.trim() === '' || link.trim() === '') {
            return false;
        }

        return true;
    }


    // ------------------------------------------------------- //

    return (
        <React.Fragment>

            <Dialog 
                open={open}
                fullWidth={true}
                maxWidth="md"
            >
                <DialogTitle>Add Period</DialogTitle>
                <DialogContent>

                    <TextField
                        autoFocus
                        margin="dense"
                        label="Name"
                        type="name"
                        fullWidth
                        variant="standard"
                        onChange={(event) => setName(event.target.value)}
                    />

                    <TextField
                        margin="dense"
                        label="Link"
                        fullWidth
                        variant="standard"
                        onChange={(event) => setLink(event.target.value)}
                    />
                </DialogContent>

                <DialogActions>
                    <Button onClick={handleAdd} disabled={!addEnabled()}>Add</Button>
                    <Button onClick={handleClose} color='secondary'>Cancel</Button>
                </DialogActions>
            </Dialog>

        </React.Fragment>
    )
}